import type { FC } from 'react'
import styled from 'styled-components'

import SmallPill from '@/components/SmallPill'

interface Props {
  error?: Error
  onRetry: () => void
}

const PillContainer = styled.div`
  margin-top: 10px;
`

const UnexpectedError: FC<Props> = ({ error, onRetry }) => (
  <div>
    <div>An unexpected error occurred. {error?.message}</div>
    <PillContainer>
      <SmallPill onClick={onRetry}>Retry</SmallPill>
    </PillContainer>
  </div>
)

export default UnexpectedError
